import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { collection, query, where, getDocs, doc, setDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { CircularProgress } from "@mui/material";
import { useUserAuth } from "../context/UserAuthContext";
import { db } from "../firebase";

const AcceptInvite = () => {
    const { user } = useUserAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [status, setStatus] = useState("processing");
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!user?.uid || !token) return;

        const accept = async () => {
            try {
                // Query invitation by token
                const q = query(
                    collection(db, "invitations"),
                    where("token", "==", token),
                    where("status", "==", "pending")
                );
                const snap = await getDocs(q);

                if (snap.empty) {
                    setStatus("error");
                    setError("This invitation is invalid or has already been used.");
                    return;
                }

                const inviteDoc = snap.docs[0];
                const invite = inviteDoc.data();

                // Create member user doc
                await setDoc(doc(db, "users", user.uid), {
                    role: "member",
                    orgId: invite.orgId,
                    email: user.email || "",
                    displayName: user.displayName || "",
                }, { merge: true });

                // Add UID to org's members array
                await updateDoc(doc(db, "organizations", invite.orgId), {
                    members: arrayUnion(user.uid),
                });

                // Mark invitation as accepted
                await updateDoc(inviteDoc.ref, { status: "accepted" });

                setStatus("success");
                navigate("/auth");
            } catch (err) {
                console.error("Accept invite error:", err);
                setStatus("error");
                setError("Something went wrong accepting the invitation. Please try again.");
            }
        };

        accept();
    }, [user, token, navigate]);

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            backgroundColor: "#f9fafb",
        }}>
            <div style={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                border: "1px solid #e5e7eb",
                padding: "48px",
                textAlign: "center",
                maxWidth: "400px",
            }}>
                {status === "processing" && (
                    <>
                        <CircularProgress style={{ color: "#825ee7", marginBottom: "24px" }} />
                        <h3 style={{ marginBottom: "8px" }}>Accepting invitation...</h3>
                        <p style={{ color: "#666" }}>Please wait while we set up your account.</p>
                    </>
                )}
                {status === "error" && (
                    <>
                        <h3 style={{ marginBottom: "8px", color: "#dc2626" }}>Invitation Error</h3>
                        <p style={{ color: "#d32f2f" }}>{error}</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default AcceptInvite;
